import Markdown from "react-markdown";

import "./index.css";

export const MarkdownField = (props) => {
  return <Markdown className="markdown" {...props} />;
};
